module.exports = __webpack_public_path__ + "static/img/b5_01.e575d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/b5_01.jpg
// module id = +TxW
// module chunks = 3